import { render, staticRenderFns } from "./blogList.vue?vue&type=template&id=5007b808&scoped=true"
import script from "./blogList.vue?vue&type=script&lang=js"
export * from "./blogList.vue?vue&type=script&lang=js"
import style0 from "./blogList.vue?vue&type=style&index=0&id=5007b808&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007b808",
  null
  
)

export default component.exports